import styled from 'styled-components'

export const Sidebar = styled.div`
  flex: 0 1 100%;
  padding-top: 1rem;
  border-top: 1px solid ${props => props.theme.colors.cobalt};

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex: 0 1 14.3%;
    border-top: 2px solid ${props => props.theme.colors.cobalt};
  }
`

export const Date = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
`
